

const Columns = [
  {
    Header: "Img",
    accessor: "img",
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "dollar",
    accessor: "dollar",
  },
  {
    Header: "Stakes",
    accessor: "stakes",
  },
  {
    Header: "Seats",
    accessor: "seats",
  },
  {
    Header: "Pot",
    accessor: "pot",
  },
  {
    Header: "Stack",
    accessor: "StackName",
  },
  {
    Header: "Players",
    accessor: "Players",
  },
  {
    Header: "Average Pot",
    accessor: "Average_Pot",
  },
]

const Columns_lb = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Stakes",
    accessor: "stakes",
  },
  {
    Header: "Game",
    accessor: "game",
  },
  {
    Header: "Seats",
    accessor: "seats",
  },
  {
    Header: "state",
    accessor: "stateImg",
  }
]

const Columns1 = [
  {
    Header: "Img",
    accessor: "img",
  },
  // {
  //   Header: "Name",
  //   accessor: "name",
  // },
  // {
  //   Header: "Stakes",
  //   accessor: "stakes",
  // },
  // {
  //   Header: "Game",
  //   accessor: "game",
  // },
  // {
  //   Header: "Pot",
  //   accessor: "pot",
  // },
  // {
  //   Header: "Wait",
  //   accessor: "wait",
  // },
  // {
  //   Header: "P/F",
  //   accessor: "pf",
  // },
  // {
  //   Header: "H/H",
  //   accessor: "hh",
  // },
  // {
  //   Header: "Seats",
  //   accessor: "seats",
  // }
];
const UM = { Columns, Columns1, Columns_lb }
export default UM;